module.exports = __webpack_public_path__ + "media/theme/psn-501367de.png";